import { ISearchWidget } from 'features/search-widget';

const fewoDirektSearchWidgetConfig: Record<string, ISearchWidget> = {
  'fewo-direkt': {
    branding: {
      logo: {
        url: 'https://www.fewo-direkt.de/_dms/header/logo.svg?siteid=9003020&locale=de_DE&3ec60977',
        description: 'FeWo-direkt.de',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
    ],
    search: {
      hostname: 'www.fewo-direkt.de',
      searchParams: {
        siteid: '9003020',
        langid: '1031',
      },
      stays: {
        pathname: '/search',
      },
    },
  },
};

export { fewoDirektSearchWidgetConfig };
